const t = "user-location";
class i {
  constructor() {
    this.position = { lat: 0, lng: 0 }, this.init();
  }
  init() {
    this.position = JSON.parse(localStorage.getItem(t) || "{}");
  }
  set(o) {
    this.position = {
      lat: o.lat,
      lng: o.lng
    }, localStorage.setItem(t, JSON.stringify(this.position));
  }
  hasValues() {
    return !!Object.keys(this.position).length;
  }
  get() {
    return this.position;
  }
  clear() {
    localStorage.removeItem(t), this.position = {};
  }
}
const e = new i();
export {
  e as l
};
